module.exports = __webpack_public_path__ + "static/media/29COICT3.8b37ca58.jpg";